import { STORE_TOOLTIP_DATA, DELETE_TOOLTIP_DATA } from './Tooltip.types';

const initialState = {};
export default (state = initialState as any, action) => {
  switch (action.type) {
    case STORE_TOOLTIP_DATA: {
      return {
        ...state,
        [action.payload.id]: action.payload.data,
      };
    }

    case DELETE_TOOLTIP_DATA: {
      const newState = { ...state };
      delete newState[action.payload.id];
      return {
        ...newState,
      };
    }
  }
  return state;
};
